import { useMutation } from 'react-query'
import request from '../request'

export const useDeleteUploadById = () => {
  return useMutation(({ id }: { id: number }) =>
    request({
      url: `/uploads/${id}`,
      method: 'DELETE',
    }),
  )
}
